import React from "react";

/** Blueflames flame mark — the brand icon, served from /blueflames-icon.png. */
export default function FlameMark({ size = 20, className = "", animate = false }) {
  return (
    <img
      src="/blueflames-icon.png"
      alt=""
      width={size}
      height={size}
      style={{ width: "auto", height: size, maxWidth: size, objectFit: "contain" }}
      className={`${className} ${animate ? "flame-animate" : ""}`}
      aria-hidden="true"
    />
  );
}
